const React = require('react')
const { useState, useEffect } = require('react')
const { useParams } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { TableHeader, TableFooterWithoutLimit } = require('@components/table')

const { TokenTransfersTable } = require('./transfersTable.token')

require('@styles/pages/address/transactions.address.css')

const TokenTransfers = props => {
    const { data } = props
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const params = new URLSearchParams(location.search)

    const { getTokenTransfers } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [tokenTransfersData, setTokenTransfersData] = useState()
    const [userAddress, setUserAddress] = useState(params.get('a') ? params.get('a').toLowerCase() : null)
    const [page, setPage] = useState(Number(params.get('p')) || 1)

    const [totalPages, setTotalPages] = useState(0)

    const [title, setTitle] = useState()
    const [subtitle, setSubtitle] = useState()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const userAddressParam = params.get('a') ? params.get('a').toLowerCase() : null

        if (userAddressParam && userAddressParam !== address) {
            setUserAddress(userAddressParam)
        }

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [tokenTransfersResponse] = await Promise.all([
                    getTokenTransfers(page, 25, {
                        ...(address && { address }),
                        ...(userAddress && { userAddress })
                    })
                ])

                if (tokenTransfersResponse) {
                    setTokenTransfersData(tokenTransfersResponse)

                    setTitle(
                        `More than ${tokenTransfersResponse.totalItems.toLocaleString()} transaction${
                            tokenTransfersResponse.totalItems === 1 ? '' : 's'
                        } found`
                    )

                    setSubtitle(
                        tokenTransfersResponse.totalItems > 10_000 ? 'Showing the last 10_000 transactions' : undefined
                    )

                    setTotalPages(
                        tokenTransfersResponse.totalItems > 10_000 ? 10_000 / 25 : tokenTransfersResponse.totalPages
                    )
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [address, network, page])

    return (
        <div className='box table-section' style={{ paddingTop: !tokenTransfersData?.totalItems ? 0 : undefined }}>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {tokenTransfersData?.totalItems == 0 ? (
                        <>
                            <TokenTransfersTable data={tokenTransfersData?.items} overviewData={data} />
                        </>
                    ) : (
                        <>
                            <TableHeader
                                title={title}
                                subtitle={subtitle}
                                page={page}
                                limit={25}
                                totalPages={totalPages}
                            />
                            <TokenTransfersTable data={tokenTransfersData?.items} overviewData={data} />
                            <TableFooterWithoutLimit page={page} limit={25} totalPages={totalPages} />
                        </>
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { TokenTransfers }
